import * as React from 'react';
import { styled } from '@mui/material/styles';

/** Display a flexbox centered message */
type MessageProps = {
    children: React.ReactNode;
};

const StyChartMessage = styled('div', {
    name: 'StyChartMessage',
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    fontSize: '2em',

    '& p': {
        marginLeft: '1rem',
        lineHeight: 'normal',
    },
});

const ChartMessage = (props: MessageProps): React.ReactElement => (
    <StyChartMessage>{props.children}</StyChartMessage>
);

export default ChartMessage;
